import { MutationTree } from 'vuex';

import { AuthenticationState } from './types';
import { CustomUser } from '@/models/custom-user.model';

export const mutations: MutationTree<AuthenticationState> = {
    loginRequest(state: any) {
        state.inFlight = true;
    },
    loginFailure(state: any) {
        state.inFlight = false;
        state.user = null;
        state.token = null;
    },
    loginSuccess(state: any, user: CustomUser) {
        state.inFlight = false;
        state.user = user;
        state.token = user.token;
    },
    updateUserRequest(state: any) {
        state.inFlight = true;
    },
    updateUserFailure(state: any) {
        state.inFlight = false;
    },
    updateUserSuccess(state: any, user: CustomUser) {
        state.inFlight = false;
        state.user = user;
        state.token = user.token;
    },
    logoutSuccess(state: any) {
        state.inFlight = false;
        state.user = null;
        state.token = null;
    },
};
